import { Box, Divider, Icon, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { faClock, faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { css } from '@emotion/react';

type Props = {
  location: string;
  date: string;
};

const SessionInfo = ({ location, date }: Props) => {
  return (
    <Box component="section" mb={12} css={styleSessionInfo}>
      <Box css={styleSessionInfoWrapper}>
        <Icon icon={faLocationDot} color="blue.7" size={14} css={styleSessionInfoIcon} />
        <Text color="gray.7" weight="bold" css={styleSessionInfoText}>
          {location}
        </Text>
      </Box>
      <Divider orientation="vertical" height="12px" css={{ alignSelf: 'center' }} color="#EAECEF" />
      <Box css={styleSessionInfoWrapper}>
        <Icon icon={faClock} color="blue.7" size={14} css={styleSessionInfoIcon} />
        <Text color="gray.7" weight="bold" css={styleSessionInfoText}>
          {date}
        </Text>
      </Box>
    </Box>
  );
};

const styleSessionInfoText = css({
  fontSize: '16px',
  [desktopFirstMediaQuery.mobile]: {
    fontSize: '14px'
  }
});

const styleSessionInfo = css({
  display: 'flex',
  gap: 8
});

const styleSessionInfoWrapper = css({
  display: 'flex',
  alignItems: 'center'
});

const styleSessionInfoIcon = css({
  marginRight: '6px'
});

export default SessionInfo;
